// 2026-10-04 — explicit instruction: every timestamp shown ANYWHERE in this
// app (Report Storage, Audit Log, Admin dashboard, RCM panels — library,
// AI, and admin alike) must display in US Eastern time, labeled "EST"
// explicitly so whoever's reading it never has to guess. Storage stays UTC
// (every ISO string this app writes/reads from Mongo/GCS is already UTC —
// that's correct and unchanged); this only affects DISPLAY.
//
// Uses the real IANA zone "America/New_York" for the actual time math (so
// it's correctly DST-aware — no off-by-an-hour bugs around the March/
// November changeovers), but always labels the result "EST" per the
// explicit instruction, rather than flipping the label to "EDT" in summer.
export function formatEST(iso, { dateOnly = false } = {}) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso);
    const opts = dateOnly
      ? { month: "short", day: "numeric", year: "numeric", timeZone: "America/New_York" }
      : { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", timeZone: "America/New_York" };
    return `${d.toLocaleString("en-US", opts)} EST`;
  } catch {
    return String(iso);
  }
}
